// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collapse-running-work-session-btn {
	margin: -0.5rem -0.5rem 0  0;
}

.collapsed #elapsedTimeCollapsed {
	display: flex;
}

.collapsed #runningWorkSession #registerSessionBtn {
	display: block;
}

.collapsed #runningWorkSessionDetails {
	display: none;
}

.collapsed #runningWorkSession{
	color: var(--text-high-emp);
	display: flex;
	left: auto;
	right: 0;
	width: 100%;
	/* padding: 1em 1em .5em 1.6em; */
}

#activeWorkSessionDisplay .icon-double-arrow-down {
	display: block;
	transform: rotate(0deg);
	transition: .4s all;
}

#activeWorkSessionDisplay.collapsed .icon-double-arrow-down {
	transform: rotate(180deg);
}

#descriptionBox {
    /* border: none; */
    box-sizing: border-box;
	resize: none;
}

#descriptionBox::placeholder {
	color: var(--text-low-emp);
}

#descriptionBoxStatus {
	bottom: 0;
	font-size: 1.2rem;
	line-height: 1.2em;
	height: 1.6em;
	padding: .3em;
	position: absolute;
	right: 0;
	width: 1.6em;
}

#descriptionBoxStatus::after,  
#descriptionBoxStatus::before {
	font-family: "timecorder" !important;
	/* speak: none; */
	font-style: normal;
	font-weight: normal;
	font-variant: normal;
	text-transform: none;
	line-height: 1;

	/* Better Font Rendering =========== */
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;

	bottom: 3px;
	display: block;
	position: absolute;
	right: 3px;
}

#descriptionBoxStatus.error::before {
	color: #d9534f;
	content: "\\e908";
}

@keyframes changeSavedContent {
	0% {
		color: #398439;
	}
	50% {
		color: #398439;
	}
	100% {
		color: #FFFFFF;
	}
}

#descriptionBoxStatus.saved::after {
	animation: changeSavedContent 5s;
	color: #FFFFFF;/*#5bc0de;*/
	content: "\\e907";
}

@keyframes changeWaitingContent {
	0% {
		color: #f0ad4e;
	}
	50% {
		color: #FFFFFF;
	}
	100% {
		color: #f0ad4e;
	}
}

#descriptionBoxStatus.waiting::after {
	animation: changeWaitingContent 3s linear infinite alternate;
	color: #FFFFFF;
	content: "\\e906";
}

#elapsedTimeCollapsed {
	display: none;
} 

#runningWorkSession #registerSessionBtn {
	display: none;
}

#runningWorkSessionDetails {
	display: flex;
}

#runningWorkSession {
    bottom: 0px;
	left: 0;
    position: fixed;
	right: 0;
	top: auto;
	z-index: 99;
}

#runningWorkSession {
	background: rgba(var(--bg-primary-rgb), .9);
    box-shadow: 0 0.1rem 2.5rem 0.5rem rgb(var(--shadow-rgb) / 40%);
}

#runningWorkSession .container-fluid {
    box-shadow: none;
}

@media (min-width: 768px) { 
	.collapsed #runningWorkSession {
		width: fit-content;
	}

	#runningWorkSession .container-fluid {
		box-shadow: 0 0.1rem 2.5rem 0.5rem rgb(var(--shadow-rgb) / 40%);
	}
}`, "",{"version":3,"sources":["webpack://./src/components/activeWorkSessionDisplay/style.css"],"names":[],"mappings":"AAAA;CACC,4BAA4B;AAC7B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,2BAA2B;CAC3B,aAAa;CACb,UAAU;CACV,QAAQ;CACR,WAAW;CACX,iCAAiC;AAClC;;AAEA;CACC,cAAc;CACd,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;CACzB,YAAY;AACb;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,SAAS;CACT,iBAAiB;CACjB,kBAAkB;CAClB,aAAa;CACb,aAAa;CACb,kBAAkB;CAClB,QAAQ;CACR,YAAY;AACb;;AAEA;;CAEC,oCAAoC;CACpC,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,oBAAoB;CACpB,oBAAoB;CACpB,cAAc;;CAEd,sCAAsC;CACtC,mCAAmC;CACnC,kCAAkC;;CAElC,WAAW;CACX,cAAc;CACd,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC;EACC,cAAc;CACf;CACA;EACC,cAAc;CACf;CACA;EACC,cAAc;CACf;AACD;;AAEA;CACC,gCAAgC;CAChC,cAAc,CAAC,WAAW;CAC1B,gBAAgB;AACjB;;AAEA;CACC;EACC,cAAc;CACf;CACA;EACC,cAAc;CACf;CACA;EACC,cAAc;CACf;AACD;;AAEA;CACC,4DAA4D;CAC5D,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;IACI,WAAW;CACd,OAAO;IACJ,eAAe;CAClB,QAAQ;CACR,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,2CAA2C;IACxC,+DAA+D;AACnE;;AAEA;IACI,gBAAgB;AACpB;;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,+DAA+D;CAChE;AACD","sourcesContent":[".collapse-running-work-session-btn {\r\n\tmargin: -0.5rem -0.5rem 0  0;\r\n}\r\n\r\n.collapsed #elapsedTimeCollapsed {\r\n\tdisplay: flex;\r\n}\r\n\r\n.collapsed #runningWorkSession #registerSessionBtn {\r\n\tdisplay: block;\r\n}\r\n\r\n.collapsed #runningWorkSessionDetails {\r\n\tdisplay: none;\r\n}\r\n\r\n.collapsed #runningWorkSession{\r\n\tcolor: var(--text-high-emp);\r\n\tdisplay: flex;\r\n\tleft: auto;\r\n\tright: 0;\r\n\twidth: 100%;\r\n\t/* padding: 1em 1em .5em 1.6em; */\r\n}\r\n\r\n#activeWorkSessionDisplay .icon-double-arrow-down {\r\n\tdisplay: block;\r\n\ttransform: rotate(0deg);\r\n\ttransition: .4s all;\r\n}\r\n\r\n#activeWorkSessionDisplay.collapsed .icon-double-arrow-down {\r\n\ttransform: rotate(180deg);\r\n}\r\n\r\n#descriptionBox {\r\n    /* border: none; */\r\n    box-sizing: border-box;\r\n\tresize: none;\r\n}\r\n\r\n#descriptionBox::placeholder {\r\n\tcolor: var(--text-low-emp);\r\n}\r\n\r\n#descriptionBoxStatus {\r\n\tbottom: 0;\r\n\tfont-size: 1.2rem;\r\n\tline-height: 1.2em;\r\n\theight: 1.6em;\r\n\tpadding: .3em;\r\n\tposition: absolute;\r\n\tright: 0;\r\n\twidth: 1.6em;\r\n}\r\n\r\n#descriptionBoxStatus::after,  \r\n#descriptionBoxStatus::before {\r\n\tfont-family: \"timecorder\" !important;\r\n\t/* speak: none; */\r\n\tfont-style: normal;\r\n\tfont-weight: normal;\r\n\tfont-variant: normal;\r\n\ttext-transform: none;\r\n\tline-height: 1;\r\n\r\n\t/* Better Font Rendering =========== */\r\n\t-webkit-font-smoothing: antialiased;\r\n\t-moz-osx-font-smoothing: grayscale;\r\n\r\n\tbottom: 3px;\r\n\tdisplay: block;\r\n\tposition: absolute;\r\n\tright: 3px;\r\n}\r\n\r\n#descriptionBoxStatus.error::before {\r\n\tcolor: #d9534f;\r\n\tcontent: \"\\e908\";\r\n}\r\n\r\n@keyframes changeSavedContent {\r\n\t0% {\r\n\t\tcolor: #398439;\r\n\t}\r\n\t50% {\r\n\t\tcolor: #398439;\r\n\t}\r\n\t100% {\r\n\t\tcolor: #FFFFFF;\r\n\t}\r\n}\r\n\r\n#descriptionBoxStatus.saved::after {\r\n\tanimation: changeSavedContent 5s;\r\n\tcolor: #FFFFFF;/*#5bc0de;*/\r\n\tcontent: \"\\e907\";\r\n}\r\n\r\n@keyframes changeWaitingContent {\r\n\t0% {\r\n\t\tcolor: #f0ad4e;\r\n\t}\r\n\t50% {\r\n\t\tcolor: #FFFFFF;\r\n\t}\r\n\t100% {\r\n\t\tcolor: #f0ad4e;\r\n\t}\r\n}\r\n\r\n#descriptionBoxStatus.waiting::after {\r\n\tanimation: changeWaitingContent 3s linear infinite alternate;\r\n\tcolor: #FFFFFF;\r\n\tcontent: \"\\e906\";\r\n}\r\n\r\n#elapsedTimeCollapsed {\r\n\tdisplay: none;\r\n} \r\n\r\n#runningWorkSession #registerSessionBtn {\r\n\tdisplay: none;\r\n}\r\n\r\n#runningWorkSessionDetails {\r\n\tdisplay: flex;\r\n}\r\n\r\n#runningWorkSession {\r\n    bottom: 0px;\r\n\tleft: 0;\r\n    position: fixed;\r\n\tright: 0;\r\n\ttop: auto;\r\n\tz-index: 99;\r\n}\r\n\r\n#runningWorkSession {\r\n\tbackground: rgba(var(--bg-primary-rgb), .9);\r\n    box-shadow: 0 0.1rem 2.5rem 0.5rem rgb(var(--shadow-rgb) / 40%);\r\n}\r\n\r\n#runningWorkSession .container-fluid {\r\n    box-shadow: none;\r\n}\r\n\r\n@media (min-width: 768px) { \r\n\t.collapsed #runningWorkSession {\r\n\t\twidth: fit-content;\r\n\t}\r\n\r\n\t#runningWorkSession .container-fluid {\r\n\t\tbox-shadow: 0 0.1rem 2.5rem 0.5rem rgb(var(--shadow-rgb) / 40%);\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
